import { render, staticRenderFns } from "./SetJob.vue?vue&type=template&id=480b9cc1&scoped=true&"
import script from "./SetJob.vue?vue&type=script&lang=js&"
export * from "./SetJob.vue?vue&type=script&lang=js&"
import style0 from "./SetJob.vue?vue&type=style&index=0&id=480b9cc1&scoped=true&lang=css&"
import style1 from "./SetJob.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480b9cc1",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
